<template lang="html">
  <div class="loading-layout">
    <page-header />

    <p class="text text-center">
      {{ loadingText }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import PageHeader from "../ui/PageHeader.vue"

interface LoadingLayoutProps {
  loadingText: string
}

const { loadingText = "" } = defineProps<LoadingLayoutProps>()
</script>
